import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { BuildTalents, getDefaultName } from '../utils'
import { loadCity, loadCourses, loadJuries, loadTalents } from '../utils/Network'
import { getUsersFilterSelectStyles, makeDarkSelectStyles } from './selectStyles';

export default function SelectYear({ callback, value, width ,name , future_only, usersFilter, placeholder, border }) {

    const [SelectOptions, setSelectOptions] = useState([]);

    const customStyles = usersFilter
        ? getUsersFilterSelectStyles({ width: width || '100px', border: 1 })
        : makeDarkSelectStyles({ width: width || '100px', border });


    var year_start = new Date().getFullYear() - 60;
    if (future_only)
        year_start = new Date().getFullYear();
    const year_end = new Date().getFullYear() +5;
    const years_array = range(year_start, year_end);
    


    function range(start, end) {
        var foo = [];
        for (var i = start; i <= end; i++) {
            foo.push(i);
        }
        return foo;
    }
    
    var options = []
    Array.from(years_array, (e, i) => {
        var option = null;
        option = {
            label: years_array[i],
            value: years_array[i]
        }
        options.push(option)
    })

    const handleSelect = (e) => {
        var value = e.value;
        callback(value, name)

    }

    return (
        <>
            <div className="filter-select">
                <Select options={options}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder={placeholder || "Year"}
                    value={options && options.filter(obj => obj.value == value)}
                    menuPortalTarget={usersFilter ? document.body : undefined}
                    menuPosition={usersFilter ? 'fixed' : undefined}
                />
            </div>

        </>
    )
}
